<template>
  <div class="custom-date-picker-item">
    <v-menu
      v-model="showPicker"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="computedDateFormatted"
          :label="`${defaultLabel}`"
          prepend-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
          color="white"
        ></v-text-field>
      </template>
      <v-date-picker
        class="calendar-proper"
        color="grey"
        v-model="date"
        @input="showPicker = false"
        show-adjacent-months
      ></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
export default {
  mounted() {
    this.date = Date.parse(this.defaultDate)
      ? new Date(this.defaultDate).toISOString().substr(0, 10)
      : new Date().toISOString().substr(0, 10);
  },
  data() {
    return {
      date: this.date ?? new Date().toISOString().substr(0, 10),
      dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      showPicker: false,
    };
  },

  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },

  watch: {
    date(val) {
      this.dateFormatted = this.formatDate(this.date);
      this.$emit("dateChanged", this.dateFormatted);
    },
  },

  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    manuallySetDate(dt) {
      this.date = Date.parse(dt) ? new Date(dt) : new Date();
    },
  },
  props: {
    defaultLabel: {
      type: String,
      default: "Select Date . . .",
    },
    defaultDate: {
      type: [String, Date],
      default: new Date().toISOString().substr(0, 10),
    },
  },
};
</script>

<style lang="scss">
.custom-date-picker-item {
  & * {
    color: white !important;
    font-weight: bolder;
  }
}
</style>
